import React from 'react';
import cx from 'classnames';

import Button from 'app/components/ui/Button';
import { TZKT_EXPLORER_URL, TABLET_WIDTH } from 'app/utils/defaults';
import BookmarkSvg from 'app/components/common/Bookmark';
import { useWindowSize } from 'app/utils/windowResize';

import { shortize } from 'app/utils/helpers';
import s from './Section.module.sass';

type SectionProps = {
  title: string
  to?: string
  address?: boolean
  head?: boolean
};

const Section: React.FC<SectionProps> = ({
  title,
  address,
  to,
  head,
  children,
}) => {
  const { width } = useWindowSize();

  const isTablet = width <= TABLET_WIDTH;

  return (
    <section className={cx(s.root)}>
      <div className={cx(s.wrapper, { [s.addressWrapper]: address })}>
        {head ? (
          <h1 className={cx(s.title)}>
            {(address && isTablet) ? shortize(title) : title}
          </h1>
        ) : (
          <h3 className={cx(s.title)}>
            {title}
          </h3>
        )}

        {to && (
        <Button sizeT="small" theme="senary" to={to}>
          See more
        </Button>
        )}

        {address && (
          <div className={cx(s.interactive)}>
            <Button
              sizeT={isTablet ? 'small' : 'large'}
              href={`${TZKT_EXPLORER_URL}/${title}`}
              className={cx(s.button)}
            >
              {isTablet ? 'tzkt.io' : 'View on tzkt.io'}
            </Button>

            <BookmarkSvg className={cx(s.button)} />
          </div>
        )}
      </div>

      {children}
    </section>
  );
};

export default Section;
